<template>
    <div>
        <div class="header">
<!--            <h1>-->
<!--                中华人民共和国国家卫生健康委员会-->
<!--            </h1>-->
            <h1>
                成人白血病诊疗登记管理系统数据归档
            </h1>
            <h2></h2>
        </div>
        <div class="content">
            <div class="box">
                <el-row>
                    <el-col :span="9">
                        <div style="padding: 10px 40px 20px 10px;">
                            <img src="../assets/images/login_icon.png"
                                 width="100%"/>
                        </div>
                    </el-col>
                    <el-col :span="15">
                        <el-form :model="ruleForm"
                                 :rules="rules"
                                 ref="ruleForm"
                                 class="form">
                            <el-form-item prop="username">
                                <el-input v-model="ruleForm.username"
                                          size="small"
                                          placeholder="用户名"></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input v-model="ruleForm.password"
                                          size="small"
                                          show-password
                                          placeholder="密码"></el-input>
                            </el-form-item>
                            <el-form-item prop="captcha">
                                <el-input v-model="ruleForm.captcha"
                                          size="small"
                                          @keyup.enter.native="submitForm('ruleForm')"
                                          placeholder="验证码">
                                    <el-button slot="append"
                                               @click="captcha_refresh"
                                               type="text" class="acptcha">
                                        <img :src="captcha_url" height="32px" width="100px"/></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item style="padding: 0 10px">
                                <el-button type="primary"
                                           size="medium"
                                           @click="submitForm('ruleForm')"
                                           :loading="loading">登陆
                                </el-button>
                                <el-button  style="float: right"
                                           size="medium"
                                           @click="register"
                                           >注 册
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="footer">
            <el-row>
                <el-col :span="4">
                    <img src="../assets/images/login-qr.png"
                         width="120"/>
                </el-col>
                <el-col :span="20">
                    <div class="footer-content">
                        <table>
<!--                            <tr>-->
<!--&lt;!&ndash;                                <th>版权所有：</th>&ndash;&gt;-->
<!--&lt;!&ndash;                                <td> 国家卫生健康委员会 电话：010-68791976</td>&ndash;&gt;-->
<!--                            </tr>-->
                            <tr>
                                <th>系统设计：</th>
                                <td>
                                    上海交通大学医学院附属瑞金医院 <br/>
                                    转化医学国家重大科技基础设施(上海)
                                </td>

                            </tr>
                            <tr>
                                <th>技术支持：</th>
                                <td>
                                    上海交通大学网络信息中心
                                </td>
                            </tr>
                        </table>
                        <div>
                            扫描左侧二维码，加入国家白血病登记交流群
                        </div>
                        <div>
                            为了更好的网站体验，建议您使用谷歌、火狐浏览器！
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-dialog
            title="视频"
            :visible.sync="dialogVisible"
            width="75%"
            :before-close="handleClose">
            <div class="main-container">
                <video-player class="video-player-box"
                              ref="videoPlayer"
                              @ended="onPlayerEnded($event)"
                              :options="playerOptions"
                              :playsinline="true"
                              @timeupdate="onPlayerTimeupdate($event)"
                              customEventName="customstatechangedeventname">
                </video-player>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {setTimeout} from 'timers';
import 'video.js/dist/video-js.css'
import {videoPlayer} from 'vue-video-player'

export default {
    components: {
        videoPlayer
    },
    data() {
        return {
            boftime: 0,
            playerOptions: {
                width: 1000,
                muted: true,
                language: 'en',
                sources: [{
                    type: "video/mp4",
                    src: ""
                }],
            },
            dialogVisible: false,
            loading: false,
            captcha_url: '/api-rms/auth/captcha.png/?d=' + Math.random(),
            ruleForm: {
                username: '',
                password: '',
                captcha: ''
            },
            rules: {
                username: [
                    {required: true, message: '请输入用户名', trigger: 'blur'},
                    {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'}
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 4, max: 64, message: '长度在 4 到 64 个字符', trigger: 'blur'}
                ],
                captcha: [
                    {required: true, message: '请输入验证码', trigger: 'blur'},
                    {min: 4, max: 64, message: '长度在 4 到 64 个字符', trigger: 'blur'}
                ],
            }
        }
    },
    methods: {
        register(){
            this.$router.replace('/register')
        },
        onPlayerTimeupdate(player) {
            var ctime = player.currentTime()
            if ((this.boftime + 1) < ctime) {
                return this.boftime
            }
            this.boftime = ctime
        },
        // eslint-disable-next-line
        onPlayerEnded(player) {
            this.$http.post('/auth/video/')
                .then(resp => {
                    if (resp.data.code == 1) {
                        this.$router.replace('/rms/dashboard')
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        handleClose() {
            // eslint-disable-next-line
            this.$confirm('确认关闭？')
                // eslint-disable-next-line
                .then(_ => {
                    // eslint-disable-next-line
                    done();
                })
                // eslint-disable-next-line
                .catch(_ => {
                });
        },
        captcha_refresh() {
            this.captcha_url = '/api-rms/auth/captcha.png/?d=' + Math.random();
        },
        submitForm(formName) {
            var that = this
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    that.loading = true
                    setTimeout(function () {
                        let data = new FormData()
                        data.append('username', that.ruleForm.username)
                        data.append('password', that.ruleForm.password)
                        data.append('captcha', that.ruleForm.captcha)
                        that.$http
                            .post('/auth/login/', that.ruleForm)
                            .then(function (res) {
                                if (res.data.code === 1) {
                                    that.loading = false
                                    localStorage.setItem('token', res.data.token)
                                    localStorage.setItem('username', that.ruleForm.username)
                                    localStorage.setItem('is_admin', res.data.is_admin)
                                    localStorage.setItem('groups', res.data.groups)
                                    localStorage.setItem('permission', res.data.permission)
                                    if (!res.data.video_path) {
                                        that.$notify({
                                            type: 'success',
                                            message: '欢迎你,' + that.ruleForm.username + '!',
                                            duration: 3000
                                        })
                                        that.$router.replace('/rms/dashboard')
                                    } else {
                                        that.dialogVisible = true
                                        that.playerOptions['sources'] = [{
                                            src: res.data.video_path,
                                            type: "video/mp4",
                                        }]
                                    }
                                } else {
                                    that.loading = false
                                    that.captcha_refresh()
                                    that.ruleForm.captcha = ''
                                    that.ruleForm.password = ''
                                    that.$message({
                                        type: 'error',
                                        message: res.data.msg,
                                        showClose: true
                                    })
                                }
                            })
                            .catch(function (err) {
                                that.loading = false
                                that.ruleForm.captcha = ''
                                that.ruleForm.password = ''
                                that.captcha_refresh()
                                console.log(err)
                            })
                    }, 300)
                } else {
                    return false;
                }
            })
        }
    }
};
</script>

<style scoped>
.header {
    padding-top: 90px;
    color: #007cc2;
    text-align: center;
}

.footer {
    margin-left: 20%;
    overflow: hidden;
    text-align: center;
    width: 70%;
}

.footer .footer-content {
    text-align: left;
    margin: 0 auto 0 40px;
    width: auto;
    font-size: 12px;
    float: left;
}

.content {
    background: #ebeff0 url(../assets/images/login-bg.png) no-repeat;
    background-size: 100% 100%;
    padding: 50px 0;
}

.content .box {
    box-sizing: border-box;
    margin: 0 auto;
    width: 509px;
    height: 266px;
    background: url(../assets/images/login-form-bg.png);
    padding: 16px;
}

.content .box .el-row {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 30px 30px 30px 20px;
    background: #f4f4f4;
}

.content .form .el-form-item {
    margin-bottom: 14px;
}

.content .form .el-form-item__error {
    padding-top: 0;
}

.acptcha img {
    max-width: none !important;
}

</style>
